import tracking from "../tracking/tracking";

export default function initCollapsibles() {
  var elems = document.querySelectorAll(".collapsible");
  M.Collapsible.init(elems, {
    onOpenStart: (elem) => {
      tracking.track("faq.open", {
        title: elem.querySelector(".collapsible-header").innerText,
      });
    },
  });
}
